import type { ComponentPropsWithRef, ReactNode } from 'react';

import { clsx } from '~/styles/utils';

import { eyebrowStyle, titleLevelStyles, titleStyle, wrapperStyle } from './Title.css';

type Props = ComponentPropsWithRef<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'> & {
  as: `h${1 | 2 | 3 | 4 | 5 | 6}`;
  children?: ReactNode;
  eyebrow?: string;
  styleAs?: `h${1 | 2 | 3 | 4 | 5 | 6}`;
};

export const Title = ({ as, children, eyebrow, styleAs, ...delegated }: Props) => {
  const Element = as;

  return (
    <div className={wrapperStyle}>
      {eyebrow && <p className={eyebrowStyle}>{eyebrow}</p>}

      <Element {...delegated} className={clsx(titleStyle, titleLevelStyles[styleAs ?? as], delegated.className)}>
        {children}
      </Element>
    </div>
  );
};
